import UltMeta, { Meta } from "./UltMeta/index";

class CorpusPublishState extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    PUBLISH = new Meta(0, "已发布");
}

export const CORPUS_PUBLISH_STATE = new CorpusPublishState();

class CorpusLibraryState extends UltMeta {
    UNMARK = new Meta(1, "未标记");
    MARKED = new Meta(0, "已标记");
}

export const CORPUS_LIBRARY_STATE = new CorpusLibraryState();
